export default __webpack_public_path__ + "static/media/frame.e2fee36f.svg";